import PageHeader from "@/components/marketing/PageHeader";
import Locations from "@/components/marketing/Locations";
import { IMG } from "@/data/content";
import { Link } from "react-router-dom";

export default function ContactPage() {
  return <div data-testid="contact-page">
    <PageHeader overline="Contact & Locations" crumb="Contact Us" title="Serving Central & South Florida" subtitle="Corporate, regional estimating, and asphalt dispatch contacts for Ranger Construction." image={IMG.contactBanner} />
    <section className="bg-white py-10"><div className="max-w-7xl mx-auto px-5 lg:px-8 flex flex-wrap gap-3">
      <Link to="/asphalt-plants/locations" className="bg-rc-charcoal text-white rounded-full px-6 py-3 font-bold">Office & Plant Directory</Link>
      <Link to="/contact/request-a-bid" className="bg-rc-red text-white rounded-full px-6 py-3 font-bold">Submit an RFP</Link>
    </div></section>
    <Locations />
  </div>;
}
